export default "__VITE_ASSET__CTElbGR5__"